import { Component } from '@angular/core';
import { StoreService } from '../store.service';
import { ActivatedRoute, Router } from '@angular/router';
import { StoreCategory } from 'src/app/shared/modules/storeCategory';
import { ErrorService } from 'src/app/shared/error.service';
import { RegistryService } from 'src/app/registry/registry.service';
import { ToastService } from 'src/app/shared/toast/toast.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-store-category',
  templateUrl: './store-category.component.html',
  styleUrls: ['./store-category.component.css']
})
export class StoreCategoryComponent {

  products: any;
  categorySlug: any;
  category: any;
  subcategories: StoreCategory[];
  showProducts = false;

  constructor(
    private router: Router,
    public error: ErrorService,
    private actRouter: ActivatedRoute,
    private translate: TranslateService,
    private registryService: RegistryService,
    private toast: ToastService,
    private storeService: StoreService) {

  }

  ngOnInit(): void {
    this.actRouter.params.subscribe((params) => {

      // this.routerParams = params as any;
      this.categorySlug = params['slug'];

      if (params['subslug']) {
        this.showProducts = true;
        this.getSubcategory(params['slug'], params['subslug']);

      } else {
        this.showProducts = false;
        this.getCategory(this.categorySlug);
      }

    });
  }

  getProducts(categoryId: string) {
    this.showProducts = true;
    this.storeService.getSubcategoryProducts(categoryId).subscribe(products => {
      this.products = products;
      console.log(products);

    });
  }

  getCategory(slug: string) {
    this.storeService.getCategory(slug)
      .subscribe((category) => {
        if (category) {
          this.category = category[0];
          this.getSubcategories()

          this.storeService.categorySubject.next(this.category)
          this.storeService.subCategorySubject.next(null)
        }
      })
  }

  getSubcategory(slug: string, subslug: string) {
    this.storeService.getCategory(slug)
      .subscribe((category) => {
        if (category) {

          this.category = category[0];
          this.storeService.categorySubject.next(this.category)

          this.storeService.getSubcategory(this.category['id'], subslug)
            .subscribe((subcategory) => {
              if (subcategory) {

                this.category = subcategory[0];
                this.storeService.subCategorySubject.next(subcategory[0])

                this.getProducts(this.category['id'])
              }
            })
        }
      })
  }

  getSubcategories() {
    this.storeService.getSubcategories(this.category['id'])
      .subscribe(subcategories => {
        this.subcategories = subcategories as StoreCategory[];
      });
  }

  addednewItem(event: { callback: (success: boolean) => void }, product: any) {
    this.storeService.addProductToRegistry({ 
      productId: product.id, 
      registryId: this.registryService.getSelectedRegistry['uid'],
      quantity: 1 
    }).subscribe({
      next: (response) => {
        this.toast.showProductToast(
          product.name,
          this.translate.instant('Product_Added_Success'),
          product.images[0].thumbImage,
          product.id
        );
        
        event.callback(true);
      },
      error: (err) => {
        console.log(err);
        this.toast.showToast("Error with Item Added when trying to add to Registry", "error", 2000);
        event.callback(false);
      }
    });
  }

  // handleImageError(event: any): void {
  //   event.target.src = 'path/to/fallback/image.jpg'; // Replace with your fallback image path
  // }
}
